import trae from 'trae'
import configService from './config'

const quijoteluiService = trae.create({
  baseUrl: configService.apiUrl
})

export default quijoteluiService
